import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen, faCopy } from "@fortawesome/free-solid-svg-icons";
import { DESIGN_RULES, DESIGN_RULES_TEXT } from "./landing-page-design-rules";

/**
 * Nút "Quy chuẩn thiết kế" + popup nội dung, kèm nút copy toàn bộ ra text để
 * gửi cho người code trang (hoặc dán vào AI làm brief).
 */
function LandingPageDesignRules({ size = "middle" }) {
    const [open, setOpen] = useState(false);

    const copyAll = async () => {
        try {
            await navigator.clipboard.writeText(DESIGN_RULES_TEXT);
            message.success("Đã copy quy chuẩn — gửi cho người code trang");
        } catch {
            message.error("Trình duyệt chặn copy — bôi đen rồi Ctrl+C thủ công");
        }
    };

    return (
        <>
            <Button size={size} onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon={faBookOpen} className="mr-2" />
                Quy chuẩn thiết kế
            </Button>

            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                title="Quy chuẩn thiết kế Trang HTML"
                width={860}
                footer={[
                    <Button key="copy" type="primary" onClick={copyAll}>
                        <FontAwesomeIcon icon={faCopy} className="mr-2" />
                        Copy toàn bộ
                    </Button>,
                    <Button key="close" onClick={() => setOpen(false)}>
                        Đóng
                    </Button>,
                ]}
            >
                <p className="text-xs text-content-3">
                    Trang chạy trong iframe sandbox của app (không có header/footer web), nên đây là
                    điều kiện để trang hiển thị đúng ở cả 3 nơi: web, WebView nhúng (App view) và
                    trình duyệt trong app. Bấm <b>Copy toàn bộ</b> để gửi cho người code trang.
                </p>

                <div className="max-h-[60vh] overflow-y-auto pr-1">
                    {DESIGN_RULES.map((section) => (
                        <div key={section.title} className="mb-4">
                            <div className="font-semibold text-sm mb-1">{section.title}</div>
                            <ul className="list-disc pl-5 m-0 text-sm text-content-2 leading-6">
                                {section.items.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </Modal>
        </>
    );
}

export default LandingPageDesignRules;
